import { render, staticRenderFns } from "./xjApply.vue?vue&type=template&id=777353b2&scoped=true&"
import script from "./xjApply.vue?vue&type=script&lang=js&"
export * from "./xjApply.vue?vue&type=script&lang=js&"
import style0 from "./xjApply.vue?vue&type=style&index=0&id=777353b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777353b2",
  null
  
)

export default component.exports